import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

type CloseHandler = () => void;

export type NestedDialogIndexProps = {
    currentIndex: number;
    setCurrentIndex: Dispatch<SetStateAction<number>>;
};

type NestedDialogOwnProps = {
    title: string;
    isOpen: boolean;
    children: JSX.Element;
    onClose?: CloseHandler;
    playButtonAudio?: CloseHandler;
};

type NestedDialogProps = NestedDialogOwnProps & NestedDialogIndexProps;
export const NestedDialog = (props: NestedDialogProps) => {
    const {
        title,
        children,
        currentIndex,
        setCurrentIndex,
        isOpen,
        onClose,
        playButtonAudio,
    } = props;
    const { t } = useTranslation();
    return (
        <Dialog
            fullScreen
            open={isOpen}
            disableEscapeKeyDown
            className="nested-dialog hide-scroll"
        >
            <Box className={'nested-content-container'}>
                <AppBar className="nested-dialog-header">
                    <Toolbar className="nested-dialog-header-toolbar">
                        <IconButton
                            aria-label="close setting"
                            onClick={() => {
                                setCurrentIndex(currentIndex - 1);
                                playButtonAudio && playButtonAudio();
                            }}
                        >
                            <ArrowBackIosNewIcon fontSize="small" />
                        </IconButton>
                        {t(title)}
                        <IconButton
                            aria-label="close setting"
                            onClick={() => {
                                setCurrentIndex(-1);
                                onClose && onClose();
                            }}
                            sx={{ height: '2.333rem' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                {children}
            </Box>
        </Dialog>
    );
};
